'use client';

import Link from 'next/link';

import { Box } from '@chakra-ui/react';

import { Button } from 'ui';

interface DashboardStickyButtonProps {
  buttonLabel: string;
  href: string;
}

const DashboardStickyButton = ({
  buttonLabel,
  href
}: DashboardStickyButtonProps) => (
  <Box
    display={{
      base: 'flex',
      md: 'none'
    }}
    justifyContent='center'
    alignItems='center'
    position='sticky'
    ml='-15px'
    bottom={0}
    w='calc(100% + 30px)'
    px={4}
    mt='24px'
    height='93px'
    bg='white'
    overflow='hidden'
  >
    <Button
      as={Link}
      href={href}
      variant='solid'
      colorScheme='secondaryLight'
      width={{ base: '100%', sm: '209px' }}
      height='45px'
      fontSize={{ base: 15, sm: 14 }}
      lineHeight={1}
      w='full'
    >
      {buttonLabel}
    </Button>
  </Box>
);

export default DashboardStickyButton;
